import { style } from "@vanilla-extract/css";
import {
  primitiveTokens,
  semanticThemeTokens
} from "../../theme/ThemeTokens.css";

export const baseFallbackContainer = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: primitiveTokens.sizing["4x"],
  width: "100%",
  height: "100%"
});

export const baseFallbackCard = style({
  display: "flex",
  padding: primitiveTokens.sizing["9x"],
  flexDirection: "column",
  gap: primitiveTokens.sizing["6x"],
  maxWidth: "640px",
  width: "100%",
  borderRadius: primitiveTokens.radii.xl,
  background: semanticThemeTokens.loginPage.container.backgroundColor,
  borderColor: semanticThemeTokens.loginPage.container.borderColor,
  borderStyle: "solid",
  borderWidth: primitiveTokens.borderWidth.default
});

export const baseFallbackTitle = style({
  color: semanticThemeTokens.loginPage.heading.color,
  textAlign: "center",
  fontSize: primitiveTokens.sizing["6x"],
  margin: 0
});

export const baseFallbackMessage = style({
  color: semanticThemeTokens.color.textColor,
  textAlign: "center",
  fontSize: primitiveTokens.type.md,
  opacity: 0.9,
  margin: 0
});
